<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 1</div>
    <h1 class="theme-heading__title">Появление питомца в доме</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Проверенный заводчик</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-1/dog-1-1.webp" type="image/webp">
          <img src="/static/img/theme-1/dog-1-1.png" alt="Подготовка к&amp;nbsp;появлению щенка в&amp;nbsp;доме"/>
        </picture>
      </div>
      <p class="theme-point__text">Очень важно выбрать проверенного заводчика, ведь от&nbsp;этого часто зависят здоровье и&nbsp;внешность щенка.<br><br>Перед контактом с&nbsp;заводчиком постарайтесь найти данные о&nbsp;нём в&nbsp;сети: информацию о&nbsp;питомнике и&nbsp;отзывы от&nbsp;текущих владельцев. Во&nbsp;время общения узнайте у&nbsp;заводчика подробности о&nbsp;будущем питомце: дату рождения, какое питание получает щенок и&nbsp;в&nbsp;каких условиях содержится, есть&nbsp;ли документы.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Найти проверенных и&nbsp;добросовестных заводчиков можно на&nbsp;<span class="accent">профессиональной платформе Kinpet</span>. Там представлены заводчики со&nbsp;знаком PRO, что гарантирует безопасность сделки и&nbsp;наличие проверенных документов</p>
      </div>
      <div class="theme-point__button">
      <a class="btn"
      href="https://kinpet.ru/rossiya/sobaki/?sellerType=pro&utm_source=royalcanin&utm_medium=banner&utm_campaign=school_pp"
      target="_blank"
      onclick="sendEventYM(
         102182679,
         'find_pet_click_btn'
       );"
      >
      Найти питомца
      </a>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">Подготовка к&nbsp;появлению щенка в&nbsp;доме</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-1/dog-1.webp" type="image/webp">
          <img src="/static/img/theme-1/dog-1.png" alt="Подготовка к&amp;nbsp;появлению щенка в&amp;nbsp;доме"/>
        </picture>
      </div>
      <p class="theme-point__text">Привычная и&nbsp;предсказуемая для собаки среда, где она может в&nbsp;определенной степени контролировать важные для нее ресурсы и&nbsp;модели общения, помогает снизить уровень стресса и&nbsp;легче адаптироваться к&nbsp;происходящим изменениям.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Когда щенок появится в&nbsp;вашем доме, ему придется приспособиться к&nbsp;новой обстановке, новым людям и&nbsp;другим питомцам, если они есть. Однако важно заранее проверить, все&nbsp;ли в&nbsp;доме подготовлено для содержания щенка или собаки.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">Опасные вещества и&nbsp;Ядовитые комнатные растения</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-1/dog-2.webp" type="image/webp">
          <img src="/static/img/theme-1/dog-2.png" alt="Опасные вещества и&amp;nbsp;Ядовитые комнатные растения"/>
        </picture>
      </div>
      <p class="theme-point__text">Необходимо хранить всю химию, чистящие средства, лекарства и&nbsp;другие токсичные вещества <span class="accent">в&nbsp;недоступном месте</span> или использовать на&nbsp;шкафах детские замки.</p>
      <p class="theme-point__text">Многие распространенные комнатные растения, в&nbsp;том числе <span class="accent">лилии, алоэ вера, плющ, диффенбахия, каладиум, сциндапсус, замиокулькас и&nbsp;цикламен, очень опасны</span> для собак и&nbsp;щенков.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Следует поместить все комнатные растения в&nbsp;недоступном для щенка месте или точно удостовериться, что имеющиеся у&nbsp;вас дома растения не&nbsp;представляют для него угрозы.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">4</span>
      <h2 class="theme-point__title">Возможные опасности и&nbsp;Мелкие предметы</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-1/dog-3.webp" type="image/webp">
          <img src="/static/img/theme-1/dog-3.jpg" alt="Возможные опасности и&amp;nbsp;Мелкие предметы"/>
        </picture>
      </div>
      <p class="theme-point__text">Исследуя окружающее пространство, щенки могут падать и&nbsp;застревать. Чтобы обеспечить их&nbsp;безопасность, установите заграждения на&nbsp;лестницах, держите окна и&nbsp;входные двери закрытыми и&nbsp;не&nbsp;допускайте выхода щенков на&nbsp;балконы.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Проверьте, нет&nbsp;ли в&nbsp;доме мест, куда питомец может попытаться протиснуться и&nbsp;застрять.</p>
      </div>
      <p class="theme-point__text">Кроме того, щенки любят все пробовать &laquo;на&nbsp;зуб&raquo;, поэтому <span class="accent">необходимо убирать из&nbsp;их&nbsp;поля зрения любые мелкие предметы</span>, которые они могут разгрызть или проглотить.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Это касается детских игрушек, канцелярских кнопок, полиэтиленовых пакетов и&nbsp;резинок. Спрячьте также все, что нужно уберечь от&nbsp;зубов щенка, например, обувь.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">5</span>
      <h2 class="theme-point__title">Электрические кабели и&nbsp;розетки</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-1/dog-5.webp" type="image/webp">
          <img src="/static/img/theme-1/dog-5.png" alt="Электрические кабели и&amp;nbsp;розетки"/>
        </picture>
      </div>
      <p class="theme-point__text">Щенки любят грызть электрические провода, а&nbsp;также могут в&nbsp;них запутаться. Спрячьте провода с&nbsp;помощью кабельных стяжек или кабель-каналов и&nbsp;закройте розетки крышками.</p>
    </div>
    <div class="theme-point"><span class="theme-point__number">6</span>
      <h2 class="theme-point__title">Свой угол и&nbsp;Место для кормления</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-1/dog-4.webp" type="image/webp">
          <img src="/static/img/theme-1/dog-4.png" alt="Свой угол и&amp;nbsp;Место для кормления"/>
        </picture>
      </div>
      <p class="theme-point__text">Подготовьте щенку тихий, укромный уголок в&nbsp;доме. Оборудуйте место для сна и&nbsp;отдыха с&nbsp;удобной лежанкой. Подстилка должна быть подходящего размера и&nbsp;легко стираться.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Если заводчик дал вам подстилку с&nbsp;запахом матери щенка, положите её&nbsp;в&nbsp;уголок для малыша.</p>
      </div>
      <p class="theme-point__text">Определите место для кормления. Подготовьте две миски&nbsp;&mdash; для воды и&nbsp;для корма. Не&nbsp;меняйте место для кормления. Наиболее гигиеничны миски из&nbsp;нержавеющей стали.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">В&nbsp;целях поддержания чистоты наполняйте миски не&nbsp;более чем на&nbsp;2/3. Соблюдайте кратность и&nbsp;режим кормления. Следите за&nbsp;тем, чтобы всегда была свежая вода и&nbsp;чистые миски!</p>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button class="btn topic__btn"
  @click="$emit('goToQuiz')"
  onclick="sendEventYM(
     102182679,
     'quiz1_click_btn'
   );"
  >Закрепить знания</button>
</template>

<script>
export default {
  name: 'LessonDogsTopic1FutureOwner',
}
</script>

<style scoped>
</style>
